import { fetchNonResearchReason } from '@/api/business/nonResearchReason';
import { useQuery } from '@tanstack/react-query';

export const useNonResearchReasonQuery = (onlyActive?: boolean) => {
  return useQuery({
    queryKey: ['non-research-reason', onlyActive],
    queryFn: () => fetchNonResearchReason(onlyActive),
  });
};
